import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // <== add the imports!
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { MenuComponent } from './shared/layout/default/menu/menu.component';
import { HomeComponent } from './components/home/home.component';
import { NegociacionComponent } from './pages/negociacion/negociacion.component';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { GestionClienteComponent } from './pages/gestion-cliente/gestion-cliente.component';
import { CargaInfoComponent } from './pages/carga-info/carga-info.component';
import { AuthInterceptorService } from './auth-interceptor.service';
import { ModalFormComponent } from './components/modal-form/modal-form.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { GestionClienteLibreComponent } from './pages/gestion-cliente-libre/gestion-cliente-libre.component';
import { EnvioMailMasivoComponent } from './pages/envio-mail-masivo/envio-mail-masivo.component';
import { UsuariosComponent } from './pages/usuarios/usuarios.component';
import { AprobacionesComponent } from './pages/aprobaciones/aprobaciones.component';
//import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { AcuerdosComponent } from './pages/acuerdos/acuerdos.component';
import { AsignacionManualComponent } from './pages/asignacion-manual/asignacion-manual.component';
import { OperacionesExtinguidasComponent } from './pages/operaciones-extinguidas/operaciones-extinguidas.component';

/*const config: SocketIoConfig = { url: 'http://localhost:4444', options: {
  transports: ['polling']
}, };*/

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotFoundComponent,
    MenuComponent,
    HomeComponent,
    NegociacionComponent,
    DataGridComponent,
    PaginationComponent,
    GestionClienteComponent,
    CargaInfoComponent,
    ModalFormComponent,
    ReportesComponent,
    GestionClienteLibreComponent,
    EnvioMailMasivoComponent,
    UsuariosComponent,
    AprobacionesComponent,
    AcuerdosComponent,
    AsignacionManualComponent,
    OperacionesExtinguidasComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    //SocketIoModule.forRoot(config)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
